import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Rodal from "rodal";
import UploadWidget from "../../../../utils/widget";
import Button from "../../../Button/Button";
import SuccessModal from "../Nip-Doc-Upload/SuccessModal";
import { useHistory } from "react-router-dom";
import Storage from "../../../../utils/storage";

export const handleDataFetchFunc = (state, setState, fileResult) => {
  let allResult = [...state.allResult];
  let index = allResult.findIndex((el) => el.id === fileResult.id);
  if (index >= 0) {
    allResult[index].url = fileResult.url;
  } else {
    allResult.push(fileResult);
  }
  setState({ allResult });
  return "success";
};

export const handleRemovalFunc = (state, setState, fileResult) => {
  state.allResult &&
    state.allResult.splice(
      state.allResult.findIndex((item) => item.id === fileResult.id),
      1
    );
  setState(JSON.parse(JSON.stringify(state)));
  return state.allResult;
};

export const submitDocsFunc = (
  state,
  selection,
  acctNumber,
  submitValues,
  wsdlUrl
) => {
  const type = "upload";
  if (
    selection === "inward_integration" ||
    selection === "inward_outward_integration"
  ) {
    const files = {
      type: selection,
      document: state.allResult,
      inward_test_data: {
        beneficiary_account_number: acctNumber,
        wsdl_url: wsdlUrl,
      },
    };
    submitValues(files, type);
  } else {
    const files = { type: selection, document: state.allResult };
    submitValues(files, type);
  }

  return "success";
};

const UploadDocs = (props) => {
  const {
    success,
    submitValues,
    selection,
    acctNumber,
    wsdlUrl,
    isSubmitting,
    documents,
  } = props;

  const history = useHistory();

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  const [modal, setModal] = useState({
    visible: false,
  });

  const res = (str) => {
    let newStr = str && str.split("_").join(" ");
    return newStr;
  };

  function handleDataFetch(fileResult) {
    handleDataFetchFunc(state, setState, fileResult);
  }
  const handleRemoval = (fileResult) => {
    handleRemovalFunc(state, setState, fileResult);
  };
  const submitDocs = () => {
    submitDocsFunc(state, selection, acctNumber, submitValues, wsdlUrl);
  };

  useEffect(() => {
    if (success) {
      setModal({ ...modal, visible: true });
    }
    // eslint-disable-next-line
  }, [success, setModal]);
  
  const hide = () => {
    setModal({ ...modal, visible: false });
    clearIntegrationStorage();
    history.push("/nip/integration");
  };

  return (
    <div>
      <div className="nip-integration-header">Document Upload</div>
      <div className="doc-upload-integration">
        {documents && documents.length > 0 ? (
          documents.map((item) => (
            <UploadWidget
              id={item.id}
              key={item.name}
              title={item.title || res(item.name)}
              handleDataFetch={handleDataFetch}
              name={item.name}
              handleRemoval={handleRemoval}
            />
          ))
        ) : (
          <div className="nip-error">
            <p>Error fetching required documents</p>
          </div>
        )}
      </div>
      <div className="doc-upload-button">
        {documents && documents.length > 0 && (
          <Button
            type="submit"
            width="50%"
            height="50px"
            text="SUBMIT"
            testId="submit"
            disabled={state.allResult.length !== 2 || isSubmitting}
            onClick={() => submitDocs()}
          />
        )}

        <Rodal
          width={Number("520")}
          height={Number("480")}
          visible={modal.visible}
        >
          <SuccessModal hide={hide} />
        </Rodal>
      </div>
    </div>
  );
};

UploadDocs.propTypes = {
  acctNumber: PropTypes.any,
  documents: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }),
  getAllApplications: PropTypes.func,
  isSubmitting: PropTypes.any,
  selection: PropTypes.string,
  submitValues: PropTypes.func,
  success: PropTypes.any,
  wsdlUrl: PropTypes.any,
};
export default UploadDocs;

export function clearIntegrationStorage() {
  Storage.remove("kit-download-single");
  Storage.remove("select-type-single");
  Storage.remove("selection-single");
  Storage.remove("upload-start-single");
}
